<template>
    <v-col cols="12" md="3">
    <v-card class="ma-2">
        <v-card-title class="title font-weight-black">
            <v-icon class="pr-3">place</v-icon> Regions
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-layout row wrap>
                    <v-col cols="12">
                        <ies-region-picker></ies-region-picker>
                    </v-col>
                    <v-col cols="12">
                        <v-btn block href="/locations/list">List All Locations</v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn block href="/regions/list">List All Regions</v-btn>
                    </v-col>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to hotels' pages
     */
    export default {
        props:[],

        data: function() {
            return {}
        },
    }
</script>
